/**
 * Phase 0.5 Component G — Revoke confirm dialog. Requires a reason
 * (server-enforced too) before revoking a role assignment.
 */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, Label, Textarea } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { useRevokeAssignment } from './hooks';
export function RevokeConfirmDialog({ open, onOpenChange, assignmentId, userId, bundleDisplayName }) {
    const [reason, setReason] = useState('');
    const revoke = useRevokeAssignment();
    const submit = async ()=>{
        if (!reason) return;
        await revoke.mutateAsync({
            id: assignmentId,
            userId,
            reason
        });
        onOpenChange(false);
        setReason('');
    };
    return /*#__PURE__*/ _jsx(AlertDialog, {
        open: open,
        onOpenChange: onOpenChange,
        children: /*#__PURE__*/ _jsxs(AlertDialogContent, {
            "data-testid": Testids.adminAccess.revokeDialog,
            children: [
                /*#__PURE__*/ _jsxs(AlertDialogHeader, {
                    children: [
                        /*#__PURE__*/ _jsxs(AlertDialogTitle, {
                            children: [
                                "Revoke ",
                                bundleDisplayName,
                                "?"
                            ]
                        }),
                        /*#__PURE__*/ _jsx(AlertDialogDescription, {
                            children: "Revokes this role assignment immediately. The user's next refresh will no longer see the bundle's permissions. The revoke is audited and the reason is recorded in the grant history."
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "space-y-1 py-2",
                    children: [
                        /*#__PURE__*/ _jsx(Label, {
                            htmlFor: "revoke-reason",
                            children: "Reason"
                        }),
                        /*#__PURE__*/ _jsx(Textarea, {
                            id: "revoke-reason",
                            "data-testid": Testids.adminAccess.revokeReasonInput,
                            value: reason,
                            onChange: (e)=>setReason(e.target.value),
                            placeholder: "Why the grant is being revoked",
                            rows: 3
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(AlertDialogFooter, {
                    children: [
                        /*#__PURE__*/ _jsx(AlertDialogCancel, {
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ _jsx(AlertDialogAction, {
                            "data-testid": Testids.adminAccess.revokeSubmitButton,
                            onClick: submit,
                            disabled: revoke.isPending || !reason,
                            children: revoke.isPending ? 'Revoking…' : 'Revoke'
                        })
                    ]
                })
            ]
        })
    });
}
